import { AuthTokensFactory } from './authTokensFactory';
import { BruntwoodSessionStoreFactory } from './bruntwoodSessionStore';
import { BruntwoodTokenStoreFactory } from './bruntwoodTokenStore';
import {
  AuthTokenSource,
  IAuthTokenFactory,
  IAuthTokenOptions,
} from './authTokenTypes';
import { DefaultWallClock } from '../../utils/time/DefaultWallClock';
import { TokenDebugger } from './TokenDebugger';
import { NexudusTokenStoreFactory } from '@portal/env/stores/authTokens/nexudusTokenStoreFactory';

const options: IAuthTokenOptions = {
  wallClock: DefaultWallClock.instance,
  debugger: new TokenDebugger(),
};

export const defaultAuthTokensFactory = new AuthTokensFactory(
  {
    bruntwoodToken: new BruntwoodTokenStoreFactory(),
    bruntwoodSession: new BruntwoodSessionStoreFactory(),
    nexudusToken: new NexudusTokenStoreFactory(),
  } as Partial<Record<AuthTokenSource, IAuthTokenFactory>> as Record<
    AuthTokenSource,
    IAuthTokenFactory
  >,
  options,
);
